const imagePath = '/Blob/images/brands/'
const imageFileExtension = '.webp'
const classNameJobTile = 'attrax-vacancy-tile'
const defaultImage = 'mitchells-butlers'

export const initialise = () => {
    if (!document.body.classList.contains('page-redesign')) return

    const jobTiles = document.querySelectorAll<HTMLDivElement>(`.${classNameJobTile}`)

    brandLogo(jobTiles)
    jobInformation(jobTiles)
}

const addLogo = (jobTile: HTMLDivElement, brandName: string) => {
    let logoContainer: HTMLDivElement = document.createElement('div')
    logoContainer.classList.add(`${classNameJobTile}__container-logo`)

    let logo: HTMLImageElement = document.createElement('img')
    logo.alt = jobTile.querySelector(`.${classNameJobTile}__option-brand .${classNameJobTile}__item-value`)?.textContent?.trim() || ''
    logo.loading = 'lazy'
    logo.src = `${imagePath}${brandName}${imageFileExtension}`

    logo.onerror = () => {
        logo.src = `${imagePath}${defaultImage}${imageFileExtension}`; 
    };
    
    logoContainer.appendChild(logo)
    jobTile.prepend(logoContainer)
}

const brandLogo = (jobTiles: NodeListOf<HTMLDivElement>) => {
    jobTiles.forEach((jobTile) => {
        const optionBrand = jobTile.querySelector<HTMLDivElement>(`.${classNameJobTile}__option-brand`)
        if (!optionBrand) return
        
        const brandName: string = optionBrand.className
        .split(' ')
        .find((className: string) => className.startsWith(`${classNameJobTile}__option-brand--`))
        ?.replace(`${classNameJobTile}__option-brand--`, '')
        ?.trim() || ''
        if (!brandName) return

        addLogo(jobTile, brandName)
    })
}

const jobInformation = (jobTiles: NodeListOf<HTMLDivElement>) => {
    jobTiles.forEach((jobTile) => {
        const itemElements = jobTile.querySelectorAll<HTMLDivElement>(`.${classNameJobTile}__item:not(.${classNameJobTile}__title)`)
        if (itemElements.length === 0) return

        const container = document.createElement('div')
        container.classList.add(`${classNameJobTile}__container-items`)

        itemElements.forEach((item) => {
            container.appendChild(item)
        })

        jobTile.appendChild(container)
    })
}